import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';

export interface ChatReviewLocationState {
  reviewIds?: Array<number>;
  listSearch?: string;
}

export default function ChatReviewNavigation({ chatId }: { chatId: string }) {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as ChatReviewLocationState | null;
  const ids = state?.reviewIds ?? [];
  const index = ids.indexOf(Number(chatId));
  const go = (offset: number) => {
    const params = new URLSearchParams(location.search);
    params.delete('turnId');
    params.delete('messageId');
    navigate({ pathname: `/trip-planner/chats/${ids[index + offset]}`, search: params.toString() }, { state });
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ alignSelf: 'center', border: 1, borderColor: 'divider', borderRadius: 2, px: 0.5 }}
    >
      <Tooltip title={index < 0 ? 'Open a chat from the Chats list to browse in order' : 'Previous chat'}>
        <Box component="span">
          <IconButton size="small" aria-label="Previous chat" disabled={index <= 0} onClick={() => go(-1)}>
            <ChevronLeftIcon />
          </IconButton>
        </Box>
      </Tooltip>
      {index >= 0 && (
        <Typography variant="body2" sx={{ px: 1, fontVariantNumeric: 'tabular-nums' }}>
          {index + 1} / {ids.length}
        </Typography>
      )}
      <Tooltip title={index < 0 ? 'Open a chat from the Chats list to browse in order' : 'Next chat'}>
        <Box component="span">
          <IconButton
            size="small"
            aria-label="Next chat"
            disabled={index < 0 || index >= ids.length - 1}
            onClick={() => go(1)}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Tooltip>
    </Stack>
  );
}
